import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "antd";
import { PlayCircleFilled } from "@ant-design/icons";
import MenuPortal from "../Portal/MenuPortal";
//Imagenes
import SolCiu from "../../../assets/img/Portal/Observadores_Ciudadania.png";
import SolCiuOrg from "../../../assets/img/Portal/Observadores_Ciudadania-Organizacion.png";
import SolOrg from "../../../assets/img/Portal/Observadores_Organizacion.png";
import './portal.css';

const Solicitud = () => {
  function toTop() {
    window.scrollTo(0, 0);
}

  useEffect(() => {
    toTop();
  }, []);

    useEffect(() => {
      const href = window.location.href
      if (href.includes("#")) {
        const id = `${href.substring(href.indexOf("#") + 1)}`
        const anchor = document.getElementById(id)
        if(anchor){
            anchor.scrollIntoView({ behavior: "smooth" })
        }
      }
  }, []);
  
  return (
    <div className="interioresPortal new-design">
      <Row  gutter={24}>
      <Col xxl={{ span: 3 }} xl={{ span: 3  }}>
      <Link to={"/"} className="button-back">
        <PlayCircleFilled rotate="180"/> Regresar
      </Link>
      </Col>
    
      <Col xxl={{ span: 21}} xl={{ span: 21}}>
      <MenuPortal active={'solicitud:1'}/></Col>
      </Row>

     
      <h1 className="main-title">Procesos de registro de solicitudes</h1>

      <Row  gutter={24} className="interioresPortal new-design descript-text" >
        <Col xxl={{ span: 18, offset: 3 }} xl={{ span: 18, offset: 3 }} lg={{ span: 18, offset: 3 }} md={{ span: 18, offset: 3 }} sm={24} xs={24}>
          <p>
            Todos los procesos de registro de solicitudes se pueden realizar mediante el Portal de Observadoras y Observadores Electorales, para ello deberás realizar lo siguiente:
          </p>
        </Col>
      </Row>
      
      <span id="a1" />
      <Row gutter={24}>
        <Col span={24}>
          <img src={SolCiu} className="img-principal img-center" alt=""/>
          <hr className="hr-divider"></hr>
        </Col>
      </Row>    

      <span id="a2" />
      <Row gutter={24}>
        <Col span={24}>
          <img src={SolCiuOrg} className="img-principal img-center" alt=""/>
          <hr className="hr-divider"></hr>
        </Col>
      </Row> 

      <span id="a3" />
      <Row gutter={24}>
        <Col span={24}>
          <img src={SolOrg} className="img-principal img-center" alt=""/>
        </Col>
      </Row> 
      
    
    </div>
  );
};

export default Solicitud;
